import { atomWithStorage } from "jotai/utils";
import { atomFamily } from "jotai-family";

const STORAGE_KEY = (tourId: string) =>
  `trayn.onboarding-tour.completed.${tourId}`;

export const tourCompletedAtom = atomFamily((tourId: string) =>
  atomWithStorage<boolean>(STORAGE_KEY(tourId), false)
);
